import React from 'react';
import { motion } from 'framer-motion';
const FOOD_IMAGES = ['https://cdn.magicpatterns.com/uploads/n2ptwbSsTe53yFNzL5vXfH/Captura_de_pantalla_2026-03-11_133340.png', 'https://cdn.magicpatterns.com/uploads/wqUAMy7vDrD7xFcSJHGhaN/Captura_de_pantalla_2026-03-11_133354.png', 'https://cdn.magicpatterns.com/uploads/vFBj98q6W2MjFPYeaCkjfv/Captura_de_pantalla_2026-03-11_133428.png', 'https://cdn.magicpatterns.com/uploads/wMGe5eMdiuwRBHvtLunwYZ/Captura_de_pantalla_2026-03-11_133441.png'];
export function HeroSection() {
  return <section className="relative min-h-[75vh] md:min-h-screen flex items-center justify-center overflow-hidden" data-id="element-217">
      {/* Background image grid */}
      <div className="absolute inset-0 grid grid-cols-2 grid-rows-2" data-id="element-218">
        {FOOD_IMAGES.map((src, i) => <div key={i} className="relative overflow-hidden" data-id="element-219">
            <img src={src} alt="" className="absolute inset-0 w-full h-full object-cover scale-110" data-id="element-220" />
          </div>)}
      </div>

      {/* Dark overlay with gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-deep-brown/80 via-deep-brown/70 to-deep-brown/85" data-id="element-221"></div>

      {/* Subtle warm tint overlay */}
      <div className="absolute inset-0 bg-terracotta/10 mix-blend-overlay" data-id="element-222"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-32 pb-24 md:py-40" data-id="element-223">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex md:hidden items-center justify-center gap-4 mb-8" data-id="element-224">
          <div className="h-[1px] w-12 bg-gold/60" data-id="element-225"></div>
          <span className="text-gold font-medium tracking-[0.25em] text-xs uppercase" data-id="element-226">
            Carrasco, Montevideo
          </span>
          <div className="h-[1px] w-12 bg-gold/60" data-id="element-227"></div>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif text-white leading-[1.1] mb-8 md:mb-12 max-w-4xl mx-auto" data-id="element-228">
          La comida de su evento va a ser lo que todos recuerden
          <span className="block text-terracotta-light italic mt-2 text-3xl sm:text-4xl md:text-5xl" data-id="element-229">
            — para bien o para mal.
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-lg sm:text-xl text-cream/80 mb-12 md:mb-16 leading-relaxed max-w-2xl mx-auto" data-id="element-230">
          Catering artesanal de elaboración propia. Fresco, cuidado y diseñado
          para que su mesa hable por usted.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-231">
          <a href="#contacto" className="bg-terracotta hover:bg-terracotta-dark text-white px-10 py-4 rounded-sm text-center font-medium transition-all duration-300 shadow-lg hover:shadow-xl text-lg" data-id="element-232">
            Hable con nosotros
          </a>
          <a href="#nosotros" className="border border-cream/30 hover:border-cream/60 text-cream hover:text-white px-10 py-4 rounded-sm text-center font-medium transition-all duration-300 text-lg" data-id="element-233">
            Conozca más
          </a>
        </motion.div>
      </div>

      {/* Bottom fade to cream */}
      <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-t from-cream via-cream/40 to-transparent" data-id="element-234"></div>
    </section>;
}